import { AlertCircle } from "lucide-react"
import type { ProductAttribute } from "~/services/woo-commerce-service"

interface SpecificationsTabProps {
  attributes: ProductAttribute[]
}

interface NormalizedAttribute {
  id: string
  label: string
  value: string
}

export function normalizeAttributes(
  attributes: ProductAttribute[] = []
): NormalizedAttribute[] {
  return attributes
    .filter((attr) => attr.visible)
    .map((attr) => ({
      id: `spec-${attr.id || attr.name.toLowerCase().replace(/\s+/g, "-")}`,
      label: attr.name,
      value: attr.options.join(", "),
    }))
}

export function SpecificationsTab({ attributes }: SpecificationsTabProps) {
  if (!attributes.length) {
    return (
      <div className='flex flex-col items-center justify-center gap-3 rounded-lg border border-muted-foreground/30 border-dashed bg-muted/30 px-6 py-12 text-center'>
        <AlertCircle className='h-10 w-10 text-muted-foreground/60' />
        <div>
          <h3 className='font-medium text-foreground'>
            Nenhuma especificação disponível
          </h3>
          <p className='mt-1 text-muted-foreground text-sm'>
            Este produto não possui especificações técnicas no momento.
          </p>
        </div>
      </div>
    )
  }

  const specs = normalizeAttributes(attributes)

  return (
    <div className='overflow-x-auto'>
      <table className='w-full min-w-125 border-collapse'>
        <caption className='sr-only'>
          Especificações técnicas do produto
        </caption>
        <thead className='sr-only'>
          <tr>
            <th scope='col'>Atributo</th>
            <th scope='col'>Valor</th>
          </tr>
        </thead>
        <tbody>
          {specs.map((spec) => (
            <tr
              className='border-border border-b transition-colors hover:bg-muted/50'
              key={spec.id}
            >
              <th
                className='w-2/5 bg-muted/20 px-4 py-3 text-left font-medium text-foreground'
                scope='row'
              >
                {spec.label}
              </th>
              <td className='px-4 py-3 text-muted-foreground'>{spec.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
